import { i18n } from 'i18n';

export const ROUTE_PATH = '/admin/user-feedback-admin-page';
export const TITLE = i18n._('User Feedback Image');
